var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_704_180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.1995 49.4001H61.3995V57.8001C61.3995 63.7551 56.5545 68.6001 50.5995 68.6001C44.6445 68.6001 39.7995 63.7551 39.7995 57.8001V39.5601L30.0645 45.4101C27.1695 47.1351 25.3995 50.2701 25.3995 53.6301V60.7251L13.3995 67.6551C11.1045 68.9751 10.3095 71.9151 11.6445 74.2101L23.6445 95.0001C24.9645 97.2951 27.9045 98.0751 30.1995 96.7551L45.7095 87.8001H66.1995C71.4945 87.8001 75.7995 83.4951 75.7995 78.2001H78.1995C80.8545 78.2001 82.9995 76.0551 82.9995 73.4001V63.8001H84.1995C86.1945 63.8001 87.7995 62.1951 87.7995 60.2001V53.0001C87.7995 51.0051 86.1945 49.4001 84.1995 49.4001ZM106.355 43.7901L94.3545 23.0001C93.0345 20.7051 90.0945 19.9251 87.7995 21.2451L72.2895 30.2001H56.9595C55.1595 30.2001 53.4045 30.7101 51.8745 31.6551L46.8495 34.7901C45.4395 35.6601 44.5995 37.2051 44.5995 38.8551V57.8001C44.5995 61.1151 47.2845 63.8001 50.5995 63.8001C53.9145 63.8001 56.5995 61.1151 56.5995 57.8001V44.6001H84.1995C88.8345 44.6001 92.5995 48.3651 92.5995 53.0001V57.2751L104.6 50.3451C106.895 49.0101 107.675 46.0851 106.355 43.7901Z",
    fill: "#E0BA56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_704_180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white",
    transform: "translate(11 11.0001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHands);
export default __webpack_public_path__ + "static/media/hands.daaa49661e4fd9e9bb0e3a6f79b58857.svg";
export { ForwardRef as ReactComponent };